import React from "react";
import { NoActivity } from "asset/icons";
import { formatDate } from "component/flex/utils";
import { TickCircle } from "iconsax-reactjs";

const ActivityTab = ({ activity }) => {
    return (
        <div className="">
            {activity?.length > 0 ? (
                <div className="">
                    {activity?.map((item, index) => {
                        return(
                            <div className="relative flex items-start" key={index}>
                                <div className="flex flex-col items-center h-full ">
                                    <TickCircle variant="Bold" color="#11A811" size="15" />
                                    {index !== activity?.length - 1 && (
                                        <div className="after:absolute h-[50px] w-[2px] bg-green-300 after:left-2" />
                                    )}
                                </div>
                                <div className="pl-3">
                                    <p className="text-sm font-medium text-grey-10">
                                        {item?.description}
                                    </p>
                                    <div className="flex items-center gap-x-2">
                                        <span className="bg-gray-300 rounded size-1 full" />
                                        <p className="text-xs font-light">
                                            {formatDate(item?.createdAt, "custom")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                    )})}
                </div>
            ) : (
                <div className="flex flex-col items-center justify-center mt-16 py-14">
                    <NoActivity />
                    <p className="mt-4 text-sm font-medium text-gray-600">No activity yet</p>
                </div>
            )}
        </div>
    );
};

export default ActivityTab;
